import request from '@/utils/request'
/**
 *
 * 轮播图和赛事介绍管理
 *
 **/

// 获取列表接口
export const getAssemblyList = (params: any) => {
  return request({
    url: '/assembly/page',
    method: 'get',
    params
  })
}

// 修改---启用禁用接口
export const enableOrDisableAssembly = (params: any) => {
  return request({
    url: `/assembly/status/${params.status}`,
    method: 'post',
    params: { id:params.id,type: params.type }
  })
}

// 新增---新建赛事介绍
export const addAssembly = (params: any) => {
  return request({
    url: '/assembly',
    method: 'post',
    data: { ...params }
  })
}

// 新增---新建轮播图
export const addAssembly1 = (params: any) => {
  return request({
    url: '/assembly/re',
    method: 'post',
    data: { ...params }
  })
}

// 修改---新建轮播图或赛事介绍
export const updateAssembly = (params: any) => {
  return request({
    url: '/assembly',
    method: 'put',
    data: { ...params }
  })
}

// 修改页面反查详情接口
export const queryAssemblyById = (id: string | (string | null)[]) => {
  return request({
    url: `/assembly/${id}`,
    method: 'get'
  })
}

// 删除接口
export const deleteAssembly = (params) => {
  return request({
    url: '/assembly',
    method: 'delete',
    params: { ids:params.ids}
  })
}
